import QuestionnaireSelectorEditor from '../../../../FormEditors/QuestionnaireSelectorEditor';

const QuestionnaireSelectorForm = ({ control, questionnaireId, disabled }) => {
  return <QuestionnaireSelectorEditor name="questionnaire_id" control={control} questionnaireId={questionnaireId} disabled={disabled} />;
};

export default QuestionnaireSelectorForm;
